import { Box, Container, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function Footer() {
  return (
    <Box component="footer" sx={{ py: { xs: 4, md: 6 }, bgcolor: 'background.paper', borderTop: 1, borderColor: 'divider' }}>
      <Container maxWidth="lg">
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: 2, alignItems: 'start' }}>
          <Box>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>mdcv.me</Typography>
            <Typography variant="body2" color="text.secondary">The professional directory for medical providers.</Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <Link component={RouterLink} to="/merchants" underline="hover">For Businesses</Link>
            <Link component={RouterLink} to="/faq" underline="hover">FAQ</Link>
            <Link component={RouterLink} to="/privacy" underline="hover">Privacy</Link>
            <Link component={RouterLink} to="/terms" underline="hover">Terms</Link>
            <Link component={RouterLink} to="/contact" underline="hover">Contact</Link>
          </Box>
          <Box sx={{ textAlign: { xs: 'left', md: 'right' } }}>
            <Typography variant="caption" color="text.secondary">© {new Date().getFullYear()} mdcv.me</Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

